// Central registry of /info/* buying-guide pages (docs/SEO_Page_Instructions.md).
// Used by InfoPage.jsx (the hub listing) and RelatedGuides.jsx (reverse links from
// SSR search pages, docs/ssr-seo-distribution-plan.md Phase 1 item 3) - one source so
// the two can't drift apart. `keywords` are lowercase substrings matched against the
// search term to decide which guides are "related" to a given /search/{slug} page.
const infoGuides = [
  {
    title: 'Melitta Solo & Product Line',
    description:
      'מדריך מקיף על מכונות קפה Melitta Solo, כולל השוואות דגמים, טיפים ומידע על כל הסדרה.',
    path: '/info/melitta-solo',
    lastUpdated: '2025-02-03',
    keywords: ['melitta solo', 'melitta'],
  },
  {
    title: 'Sage Barista Express & Product Line',
    description:
      'מדריך מקיף על מכונת קפה Sage Barista Express, כולל השוואות דגמים, טיפים ומידע על כל הסדרה.',
    path: '/info/sage-barista-express',
    lastUpdated: '2026-02-18',
    keywords: ['sage barista express', 'sage barista', 'barista express'],
  },
];

export default infoGuides;
